import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type DeleteWorkflowRuleMutationVariables = GraphQLTypes.Exact<{
  workflowRuleId: GraphQLTypes.Scalars['String']['input'];
}>;

export type DeleteWorkflowRuleMutationResult = { __typename?: 'Mutation' } & {
  deleteWorkflowRule?: GraphQLTypes.Maybe<
    { __typename?: 'DeleteWorkflowRulePayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const DeleteWorkflowRuleDocument = /*#__PURE__*/ gql`
  mutation deleteWorkflowRule($workflowRuleId: String!) {
    deleteWorkflowRule(workflowRuleId: $workflowRuleId) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useDeleteWorkflowRuleMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowRuleMutation, { data, loading, error }] = useDeleteWorkflowRuleMutation({
 *   variables: {
 *      workflowRuleId: // value for 'workflowRuleId'
 *   },
 * });
 */
export function useDeleteWorkflowRuleMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteWorkflowRuleMutationResult, DeleteWorkflowRuleMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<DeleteWorkflowRuleMutationResult, DeleteWorkflowRuleMutationVariables>(
    DeleteWorkflowRuleDocument,
    options
  );
}
export type DeleteWorkflowRuleMutationHookResult = ReturnType<typeof useDeleteWorkflowRuleMutation>;
